import { availableLocales } from './i18n.js';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

var APP = /* @__PURE__ */ ((APP2) => {
  APP2["CF_WEBAPP"] = "CF_WEBAPP";
  APP2["COACHING_WEBAPP"] = "COACHING_WEBAPP";
  APP2["CF_RESUME_BUILDER"] = "CF_RESUME_BUILDER";
  return APP2;
})(APP || {});
class InitService {
  baseURL;
  appContext;
  firebaseMethods;
  studentContext;
  app;
  locale;
  static instance;
  constructor(baseURL, appContext, firebaseMethods, app, studentContext, locale) {
    this.baseURL = baseURL;
    this.appContext = appContext;
    this.firebaseMethods = firebaseMethods;
    this.app = app;
    this.studentContext = studentContext;
    this.locale = locale;
  }
  static init(baseURL, appContext, firebaseMethods, app, studentContext, locale) {
    if (InitService.instance) return;
    InitService.instance = new InitService(
      baseURL,
      appContext,
      firebaseMethods,
      app,
      studentContext,
      locale
    );
    const localesAcc = {
      en: { ...availableLocales.en, ...locale?.en },
      bg: { ...availableLocales.bg, ...locale?.bg },
      cs: { ...availableLocales.cs, ...locale?.cs },
      da: { ...availableLocales.da, ...locale?.da },
      de: { ...availableLocales.de, ...locale?.de },
      es: { ...availableLocales.es, ...locale?.es },
      et: { ...availableLocales.et, ...locale?.et },
      fi: { ...availableLocales.fi, ...locale?.fi },
      fr: { ...availableLocales.fr, ...locale?.fr },
      hi: { ...availableLocales.hi, ...locale?.hi },
      hr: { ...availableLocales.hr, ...locale?.hr },
      hu: { ...availableLocales.hu, ...locale?.hu },
      it: { ...availableLocales.it, ...locale?.it },
      lt: { ...availableLocales.lt, ...locale?.lt },
      lv: { ...availableLocales.lv, ...locale?.lv },
      nl: { ...availableLocales.nl, ...locale?.nl },
      no: { ...availableLocales.no, ...locale?.no },
      pl: { ...availableLocales.pl, ...locale?.pl },
      pt: { ...availableLocales.pt, ...locale?.pt },
      ro: { ...availableLocales.ro, ...locale?.ro },
      sk: { ...availableLocales.sk, ...locale?.sk },
      sl: { ...availableLocales.sl, ...locale?.sl },
      sr: { ...availableLocales.sr, ...locale?.sr },
      sv: { ...availableLocales.sv, ...locale?.sv },
      zh: { ...availableLocales.zh, ...locale?.zh }
    };
    const resources = {
      ...Object.keys(localesAcc).reduce((prev, curr) => {
        prev[curr] = { translation: localesAcc[curr] };
        return prev;
      }, {})
    };
    i18n.use(Backend).use(initReactI18next).init({
      debug: false,
      fallbackLng: "en",
      resources
    });
  }
  static getInstance() {
    if (!InitService.instance)
      throw Error(
        "Instantiate InitService factory first in the format InitService.init(auth, baseURL)"
      );
    return InitService.instance;
  }
}

export { APP, InitService as default };
